import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Vendor = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="bg-[#FAF7F2] md:px-[120px] p-[20px] md:pt-[60px] md:pb-[20px] gap-[16px] flex items-center">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="hover:bg-gray-100 rounded-full shrink-0"
          aria-label="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_vendor_back)">
              <path d="M5 12H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_vendor_back">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <h1 className="text-[20px] font-medium text-black tracking-[-1px]">List your property</h1>
      </div>

      <div className="md:px-[120px] p-[20px] md:py-[20px] flex flex-col gap-[8px] pb-10 max-w-3xl">
        <div className="bg-white rounded-[16px] p-[24px] md:p-[32px] shadow-sm">
          <p className="text-[14px] text-[#8c8c8c] leading-[1.6] mb-4">
            Run a pet-friendly stay or host pet events? We&apos;d love to hear from you. Share a few details and our
            team will reach out about listing on BookForPaws.
          </p>
          <p className="text-[14px] text-[#8c8c8c] leading-[1.6] mb-6">
            For faster help, you can also write to{' '}
            <a href="mailto:help@bookforpaws.com" className="text-[#FF5E4C] underline underline-offset-2">
              help@bookforpaws.com
            </a>
            .
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/vendor/login"
              className="inline-flex items-center justify-center rounded-full bg-black text-white text-[14px] font-medium px-6 py-3 hover:opacity-90 transition-opacity"
            >
              Vendor login
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full bg-[#FF5E4C] text-white text-[14px] font-medium px-6 py-3 hover:opacity-90 transition-opacity"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vendor;
